import { MutableRefObject, useCallback, useEffect, useState } from 'react';
import { InternalEventType, WsMessage } from '../../../clients/chat/types';
import { getPluginStore } from '../../../utils/store/getStore';

const notLastMessageRelated =
    (lastMessage: { ticketKey: string; message: WsMessage }) => (message: { ticketKey: string; message: WsMessage }) =>
        message.ticketKey !== lastMessage.ticketKey;

export default function useChatMessagesUpdates(audioEl: MutableRefObject<HTMLAudioElement>, currentTabKey: string) {
    const [messages, setMessages] = useState<{ ticketKey: string; message: WsMessage }[]>([]);

    const incomingMessageHandler = useCallback(
        (event: CustomEventInit<{ message: WsMessage; chatSessionId: string }>) => {
            const ticketKey = getPluginStore().activeChatEntities.find(
                (e) => e.chatSessionId === event.detail.chatSessionId
            ).ticketKey;

            if (ticketKey !== currentTabKey) {
                const message = {
                    ticketKey,
                    message: event.detail.message
                };
                setMessages((messages) => [message, ...messages.filter(notLastMessageRelated(message))]);
                // ring the bell here also when the browser tab is not focused
                if (audioEl.current) {
                    audioEl.current.pause();
                    audioEl.current.currentTime = 0; // to start over again
                    audioEl.current.play();
                }
            }
        },
        [audioEl, currentTabKey]
    );

    useEffect(() => {
        window.addEventListener(InternalEventType.INCOMING_MESSAGE, incomingMessageHandler);

        return () => {
            window.removeEventListener(InternalEventType.INCOMING_MESSAGE, incomingMessageHandler);
        };
    }, [incomingMessageHandler]);

    return { messages, setMessages };
}
